import { TimeChart } from '../time/chart'

export class DistancePolylineChart extends TimeChart {}
